// Global packages and components
import { clsx } from 'clsx'
import { Image, SchemaMeta, SchemaWrapper } from '~/components'

// Types
import type { SanityRefWithAlt } from '~/types'

type Props = {
  size?: number
  image: SanityRefWithAlt
  absolute?: boolean
  asImageObject?: boolean
  hideOverlay?: boolean
  /** ImageObject microdata. Off on pages whose structured data is JSON-LD only */
  withSchema?: boolean
}

// Main export
const BannerImage = ({
  size,
  image,
  absolute = true,
  asImageObject = false,
  hideOverlay = false,
  withSchema = true,
}: Props) => {
  return (
    <SchemaWrapper
      type={withSchema ? 'ImageObject' : undefined}
      prop={withSchema ? 'image' : undefined}
      className={clsx(
        'left-0 top-0 h-full w-full overflow-hidden rounded-2xl',
        {
          absolute: absolute,
          relative: !absolute,
        }
      )}
    >
      <div
        className={clsx('absolute left-0 top-0 z-[1] h-full w-full', {
          'bg-gradient-to-t from-black/40 to-transparent to-100%': !hideOverlay,
        })}
      />
      {image?.asset && (
        <>
          {withSchema && asImageObject && image.alt && (
            <>
              <SchemaMeta
                prop="name"
                content={image.alt}
              />
              <SchemaMeta
                prop="caption"
                content={image.alt}
              />
            </>
          )}
          <Image
            image={image}
            customSize={size ?? 1440}
            className="h-full w-full object-cover"
          />
        </>
      )}
    </SchemaWrapper>
  )
}

export default BannerImage
